import { StyledButton } from './styled'
import { ButtonProps } from './types'

/**
 * The primary button across the app. Three variants (primary / secondary /
 * ghost), three sizes, optional loading state. Wraps a `motion.button`
 * for hover lift + tap squish using the global Apple-spring easing.
 *
 * @param {ButtonProps} props
 * @returns {JSX.Element}
 */
const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  isLoading = false,
  isFullWidth = false,
  disabled,
  ...rest
}: ButtonProps): JSX.Element => {
  const isDisabled = disabled === true || isLoading

  return (
    <StyledButton
      variant={variant}
      size={size}
      isFullWidth={isFullWidth}
      disabled={isDisabled}
      whileHover={isDisabled ? undefined : { y: -2 }}
      whileTap={isDisabled ? undefined : { scale: 0.97 }}
      {...rest}
    >
      {isLoading ? 'Working…' : children}
    </StyledButton>
  )
}

export default Button
